import { CSpinner } from "@coreui/react";

const AppLoader = ({ height = "100vh" }) => {
  return (
    <div
      className="loaderContainer"
      style={{
        height,
      }}
    >
      <div className="loaderCircle">
        {/* Small Spinner */}
        <CSpinner className="customSpinner" />

        {/* Stable Logo */}
        <img src="/favicon.webp" alt="logo" className="loaderLogo" />
      </div>

      <style>
        {`
          .loaderContainer {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
          }

          /* Main Circle */
          .loaderCircle {
            position: relative;
            width: 54px;
            height: 54px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            box-shadow: 0 3px 12px rgba(0, 192, 243, 0.15);
          }

          /* Spinner */
          .customSpinner {
            position: absolute;
            width: 54px !important;
            height: 54px !important;
            color: #00c0f3 !important;
            opacity: 0.7;
          }

          /* Logo */
          .loaderLogo {
            width: 20px;
            height: 20px;
            object-fit: contain;
            z-index: 2;
          }

          /* Tablet */
          @media (max-width: 768px) {
            .loaderCircle {
              width: 48px;
              height: 48px;
            }

            .customSpinner {
              width: 48px !important;
              height: 48px !important;
            }

            .loaderLogo {
              width: 18px;
              height: 18px;
            }
          }

          /* Mobile */
          @media (max-width: 480px) {
            .loaderCircle {
              width: 44px;
              height: 44px;
            }

            .customSpinner {
              width: 44px !important;
              height: 44px !important;
            }

            .loaderLogo {
              width: 16px;
              height: 16px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AppLoader;
